/*
  GW: floating "Filter & Sort" button on mobile collection pages.
  Appears once the shopper scrolls past the normal Filter bar; tapping it opens the same filter drawer.
  Styling: assets/gw-card.css (.gw-filter-pill).
*/
(function () {
  function findTrigger() {
    var scope = document.querySelector('.collection-grid-section') || document;
    var els = scope.querySelectorAll('summary, button');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains('gw-filter-pill') || el.classList.contains('gw-price-band')) continue;
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt.indexOf('filter') === 0 && el.offsetParent !== null) return el;
    }
    return null;
  }

  function init() {
    if (!('IntersectionObserver' in window)) return;
    if (document.querySelector('.gw-filter-pill')) return;
    var trigger = findTrigger();
    if (!trigger) return;

    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'gw-filter-pill';
    pill.setAttribute('aria-label', 'Filter and sort');
    pill.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 6h18M6 12h12M10 18h4"/></svg><span>Filter &amp; Sort</span>';
    document.body.appendChild(pill);

    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (!e.isIntersecting && e.boundingClientRect.top < 0) {
        pill.classList.add('is-visible');
      } else {
        pill.classList.remove('is-visible');
      }
    });
    io.observe(trigger);

    pill.addEventListener('click', function () {
      var t = findTrigger() || trigger;
      if (t) t.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
